<template>
  <v-sheet class="ficha-datos" rounded outlined :class="{ 'ficha-densa': densa }">
    <v-row dense>
      <v-col
        v-for="campo in campos"
        :key="campo.clave || campo.etiqueta"
        cols="12"
        :md="campo.ancho === 'completo' ? 12 : 6"
      >
        <div class="ficha-etiqueta">{{ campo.etiqueta }}</div>
        <div class="ficha-valor" :class="{ 'ficha-valor--destacado': campo.destacado }">
          <!--
            El slot con nombre dinámico permite renderizar un valor como chip o con
            ícono sin que la ficha tenga que conocer los estados del dominio.
          -->
          <slot :name="'valor.' + campo.clave" :campo="campo">
            {{ formatear(campo.valor) }}
          </slot>
        </div>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
/**
 * Lista de pares etiqueta/valor de solo lectura: la "cabecera de detalle" que hoy
 * se reescribe a mano con v-row/v-col en media docena de pantallas.
 *
 * Es de SOLO LECTURA a propósito: sirve para que el usuario reconozca sobre qué
 * registro está por actuar (reconocer antes que recordar), no para editarlo.
 *
 * campos: [{ clave, etiqueta, valor, ancho: 'completo'|'medio', destacado }]
 */
export default {
  name: 'BaseFichaDatos',

  props: {
    campos: { type: Array, default: () => [] },
    densa: { type: Boolean, default: true },
  },

  methods: {
    // Un valor ausente se muestra como guion largo, nunca como celda vacía: el
    // usuario tiene que poder distinguir "no hay dato" de "la ficha se rompió".
    formatear(valor) {
      if (valor === null || valor === undefined || valor === '') return '—';
      return valor;
    },
  },
};
</script>

<style scoped>
.ficha-datos {
  background-color: var(--v-neutral-100-base);
  padding: 12px 16px;
}

.ficha-densa {
  padding: 8px 12px;
}

.ficha-etiqueta {
  color: var(--v-neutral-600-base);
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  line-height: 1.4;
}

.ficha-valor {
  color: var(--v-neutral-900-base);
  font-size: 0.9rem;
  line-height: 1.4;
  word-break: break-word;
}

.ficha-valor--destacado {
  font-weight: 700;
}
</style>
